export default "__VITE_ASSET__DIMmFxpy__"